import { z } from 'zod';

import { baseSlideSchema } from './baseSlideSchema';
import { SlideType } from '../../enums';
import { videoSlideItemSchema } from './slideItemTypes/videoSlideItemSchema';

export const videoSlideSchema = baseSlideSchema.and(
  z.object({
    type: z.literal(SlideType.VIDEO),
    items: z.array(videoSlideItemSchema),
  })
);

export type VideoSlideType = z.infer<typeof videoSlideSchema>;
